module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.deliverysaver', {
            url: '/deliverysaver',
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('checkout');
                    },
                ],
                navigationItems: ['InspirationService', function (inspirationService) {
                    return inspirationService.getNavigationItems();
                }],
            },
            onEnter: ['$state', 'Settings', ($state, settings) => {
                if (!(settings.deliverySaver && settings.deliverySaver.isEnabled)) {
                    $state.go('shop.inspiration');
                }
            }],
            views: {
                'left-panel@shop': {
                    controller: [
                        'navigationItems', function (navigationItems) {
                            this.menuItems = navigationItems;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-inspiration-navigation ng-if="!$breakpoints.isInSmallFormat" menu-items="$ctrl.menuItems"></wow-inspiration-navigation>',
                },
                'center-panel@shop': {
                    template: '<wow-delivery-saver-payment-setup class=""></wow-delivery-saver-payment-setup>',
                },
            },
            data: {
                pageMetadata: [
                    'PageMetadataService',
                    function (pageMetadataService) {
                        return pageMetadataService.getMetadata({
                            name: 'Delivery Saver | Woolworths',
                        });
                    },
                ],
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/deliverysaver.js